import React from 'react';
import Modal from '../../components/Modals/Modal';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import PasswordInput from '../../components/Inputs/PasswordInput';
import DividerSimple from '../../components/Dividers/DividerSimple';
import useApp from '../../store/app/appContext';

function UpdatePasswordModal({
  setShowUpdatePassword,
  showUpdatePassword
}) {
  
  const {
    updatePassword,
  } = useApp();

  const [passwords, _setPasswords] = React.useState({
    old: null,
    new: null,
    confirm: null,
  })

  const setPasswords = (data) => _setPasswords({ ...passwords, ...data })

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });
  
  const handleCancel = () => {
    setShowUpdatePassword(false);
    setFormError({
      field: '',
      msg: ''
    });
  }

  const handleSubmit = () => {
    if (passwords.old === '' || passwords.old === null) {
      setFormError({
        field: 'no-old-pw',
        msg: "Please enter your old password."
      })
      return;
    }
    if (passwords.new !== passwords.confirm) {
      setFormError({
        field: 'no-pw-match',
        msg: "Passwords don't match."
      })
      return;
    }
      if (passwords.new === '' || passwords.new === null) {
      setFormError({
        field: 'no-pw',
        msg: "Please enter a new password."
      })
      return;
    }
    passwords.confirm
    updatePassword({new: passwords.new, old: passwords.old});
    setShowUpdatePassword(false);
  }

  return (
    <Modal title={'Update password'} show={showUpdatePassword} hide={handleCancel}>
      <div className='flex flex-col justify-between mt-8'>
        <PasswordInput value={passwords.old} label={'Old password'} onChange={(e) => setPasswords({ old: e.target.value })}/>
        {formError.field === 'no-old-pw' &&
        <span className="text-red-400 text-sm">{formError.msg}</span>
        }
        <DividerSimple/>
        <PasswordInput value={passwords.new} label={'New password'} onChange={(e) => setPasswords({ new: e.target.value })}/>
        <div className='mt-4'/>
        <PasswordInput value={passwords.confirm} label={'Confirm password'} onChange={(e) => setPasswords({ confirm: e.target.value })}/>
        {(formError.field === 'no-pw-match' || formError.field === 'no-pw') &&
        <span className="text-red-400 text-sm">{formError.msg}</span>
        }
        <div className='grid grid-cols-2 gap-x-2 mt-6'>
          <SecondaryButton onClick={handleCancel} text='Cancel'/>  
          <PrimaryButton onClick={handleSubmit} text='Update'/>
        </div>
      </div>
    </Modal>
  )
}

export default UpdatePasswordModal
